import { getCurrentRole } from 'src/services/Roles/Merchants';

const ALLOWED = '1';
const DENIED = '0';
const NOT_SET = '';

export const AUTH_KEY = {
  name: 'name',
  dashboard: 'dashboard',
  products: 'products',
  product_actions: 'product_actions',
  stocks: 'stocks',
  stock_actions: 'stock_actions',
  suppliers: 'suppliers',
  supplier_actions: 'supplier_actions',
  transactions: 'transactions',
  deliveries: 'deliveries',
  users: 'users',
  user_actions: 'user_actions',
  stores: 'stores',
  store_actions: 'store_actions',
  analytics: 'analytics',
  operational: 'operational',
  visitations: 'visitations',
  work_plans: 'work_plans',
  categories: 'categories',
  category_actions: 'category_actions',
  goods_receipts: 'goods_receipts',
  stock_adjustments: 'stock_adjustments',
};

class Authentication {
  role = {
    name: '',
    dashboard: '',
    products: '',
    product_actions: '',
    stocks: '',
    stock_actions: '',
    suppliers: '',
    supplier_actions: '',
    transactions: '',
    deliveries: '',
    users: '',
    user_actions: '',
    stores: '',
    store_actions: '',
    analytics: '',
    operational: '',
    visitations: '',
    work_plans: '',
    categories: '',
    category_actions: '',
    goods_receipts: '',
    stock_adjustments: '',
  };

  async fetchPermissions() {
    await getCurrentRole().then((response) => {
      if (response.success == 1) {
        if (response.userDeletedAt != null) {
        } else {
          Object.keys(AUTH_KEY).forEach((attr) => {
            this.role[AUTH_KEY[attr]] = response.data[AUTH_KEY[attr]];
          });
        }
      }
    });
  }

  isEmpty() {
    return this.role.name == '';
  }

  isAllowed(permission) {
    return permission == ALLOWED;
  }

  isDenied(permission) {
    return permission == DENIED || permission == NOT_SET;
  }
}

export default Authentication;
